import { useDispatch } from 'react-redux';
import {
  setPopupCenterOpen,
  setPopupCenterComponentRender,
  setPopupCenterClosable,
  setPopupCenterClosingFunction,
} from '../redux/slices/popupCenterSlice';

function usePopup() {
  const dispatch = useDispatch();

  const handlePopupCenterOpen = (popupCenterOpen) => {
    dispatch(setPopupCenterOpen(popupCenterOpen));
  };

  const handlePopupCenterComponentRender = (popupCenterComponent) => {
    dispatch(setPopupCenterComponentRender(popupCenterComponent));
  };

  const handlePopupCenterClosingFunction = (popupCenterClosingFunction) => {
    dispatch(setPopupCenterClosingFunction(popupCenterClosingFunction));
  };

  const handleIsClosable = (isClosable) => {
    dispatch(setPopupCenterClosable(isClosable));
  };

  return {
    handlePopupCenterOpen,
    handlePopupCenterComponentRender,
    handlePopupCenterClosingFunction,
    handleIsClosable,
  };
}

export default usePopup;
